import { z } from 'zod';

const AlertSchema = z.object({
  status: z.boolean(),
  numberThreshold: z
    .string()
    .min(1, 'Threshold is required')
    .pipe(
      z.coerce
        .number()
        .int('Threshold must be a whole number')
        .min(0, 'Threshold must be at least 0'),
    )
    .optional(),
  percentageThreshold: z
    .string()
    .min(1, 'Threshold is required')
    .superRefine((data, ctx) => {
      // has no more than 2 decimal places
      if (data.split('.')[1]?.length > 2) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Threshold must be 2 or fewer decimal places',
        });
      }
    })
    .pipe(
      z.coerce
        .number()
        .min(0, 'Threshold cannot be negative')
        .max(100, 'Threshold must be 100 or less'),
    )
    .optional(),
  frequency: z
    .string()
    .min(1, 'Frequency must be defined')
    .pipe(
      z.coerce
        .number()
        .int('Frequency must be a whole number')
        .min(1, 'Frequency must at least 1')
        .max(72, 'Frequency must be 72 or less'),
    ),
});

/**
 * This schema is used to validate alert metrics.
 */
export const schema = z.record(AlertSchema);

export type AlertsFormStateValues = z.infer<typeof schema>;
